export default function ListItem({ children, prefix }) {
  return (
    <li className="flex flex-row gap-1">
      <span>{prefix && `(${prefix})`}</span>
      <span>{children}</span>
    </li>
  );
}
